function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

export { createCommonjsModule };
//# sourceMappingURL=_commonjsHelpers.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@stacks/connect/node_modules/@stacks/transactions/node_modules/@stacks/network/node_modules/@stacks/common/dist/_virtual/_commonjsHelpers.js
// module id = null
// module chunks = 